// extracted by mini-css-extract-plugin
export default {"container":"style_container__inc95","video":"style_video__m+dfB"};